import React, { useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form, {
  GroupItem,
  Item,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
  CustomRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { useDispatch } from "react-redux";
import { loginSuccess, setUserLoading, setUserRoleLoaded } from "../../redux/slices/authSlice";
import { useFetch, usePost } from "@hooks/useAuthApi";
import AUTH_API from "api/authApi";
import Cookies from "js-cookie";
import { jwtDecode } from 'jwt-decode';

import "./LoginForm.scss";
import { apiGet } from "api/api-auth";

import { Toast } from "devextreme-react";
import Loader from "@common-components/loader/Loader";

export default function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [passwordMode, setPasswordMode] = useState("password");
  const [visible, setVisible] = useState(false); // Default visible
  const [toastMessage, setToastMessage] = useState(""); // Default message
  const [toastType, setToastType] = useState("error"); // Default error
  const formData = useRef({ email: "", password: "" });
  const { mutate: login } = usePost("login", AUTH_API.LOGIN);

  const [token, setToken] = useState("");
    const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setVisible(true);
  };
  //   const { data: boxNumbersData } = useFetch(
  //     token ? "getUserDetails" : null,
  //     AUTH_API.getUserDetails,
  //     token ? { } : undefined
  // );
  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      setLoading(true);

      login(formData.current, {
        onSuccess: async (response) => {
          console.log("Hm@baader1122", response);

          if (response.isSuccess) {
            console.log(response.data.accessToken, "accessToken");
            console.log(response.data.refreshToken, "refreshToken");
            setToken(response.data.accessToken);

            const decodedToken = jwtDecode(response.data.accessToken);
            console.log("Decoded Token: ", decodedToken);

            Cookies.set("accessToken", response.data.accessToken, {
              secure: true,
              sameSite: "Strict",
            });
            Cookies.set("refreshToken", response.data.refreshToken, {
              secure: true,
              sameSite: "Strict",
            });
            dispatch(loginSuccess());
            const user = await apiGet(
              `${process.env.REACT_APP_API_AUTH_URL}/Users/UserDetail`
            );
     
            dispatch(setUserRoleLoaded(user.data?.role));

            console.log(user, "userssssd")
            localStorage.setItem("userDetails", JSON.stringify(user.data));
            window.dispatchEvent(new Event("userDetailsChanged"));
            if (user.data?.role === "CCPInspector") {
              navigate("/quality/fillet/ccp");

            }
            else if (user.data?.role === "QCPInspector") {
              navigate("/quality/fillet/qcp");
            }
            else {
              navigate("/quality/fillet/overview");
            }
          } else {
            showToast("error", response.errors[0]?.errorMessageEn);
          }
        },
        onError: (error) => {
          notify(
            // error.message || "Login failed. Please try again.",
            "Wrong email or password. Please try again.",
            "warning",
            3000
          );
        },
        onSettled: () => {
          setLoading(false);
        },
      });
    },
    [login, dispatch, navigate]
  );

  const getPasswordEditorOptions = (
    passwordMode,
    setPasswordMode,
    placeholder
  ) => ({
    stylingMode: "outlined",
    placeholder,
    mode: passwordMode,
    buttons: [
      {
        name: "lockIcon",
        location: "before",
        options: {
          icon: "lock",
          stylingMode: "text",
        },
      },
      {
        name: "togglePassword",
        location: "after",
        options: {
          icon: passwordMode === "password" ? "eyeopen" : "eyeclose",
          stylingMode: "text",
          onClick: () =>
            setPasswordMode((prev) =>
              prev === "password" ? "text" : "password"
            ),
        },
      },
    ],
  });

  const passwordEditorOptions = getPasswordEditorOptions(
    passwordMode,
    setPasswordMode,
    "Enter Password"
  );

  const passwordValidation = (e) => {
    const password = e.value;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isValidLength = password.length >= 8 && password.length <= 20;

    return (
      hasUpperCase &&
      hasLowerCase &&
      hasDigit &&
      hasSpecialChar &&
      isValidLength
    );
  };

  return (
    <>
      <Toast
        visible={visible}
        message={toastMessage}
        type={toastType}
        displayTime={2000}
        onHiding={() => setVisible(false)}
        position={{ my: "top right", at: "top right", offset: "10 10" }}
      />
      <form className={"login-form"} onSubmit={onSubmit}>
        {/* <p className="text-xl mb-1">Welcome to QMS! 👋🏻</p> */}
        {/* <p className="text-xs">
          Please sign in to your account and start the adventure
        </p> */}
        <Form
          formData={formData.current}
          disabled={loading}
          labelMode="outside"
          labelLocation="top"
          showColonAfterLabel={false}
          className="mt-4"
        >
          <Item
            dataField="email"
            editorType="dxTextBox"
            editorOptions={emailEditorOptions}
          >
            <RequiredRule message="Email is required" />
            <EmailRule message="Email is invalid" />
          </Item>
          <Item
            dataField="password"
            editorType="dxTextBox"
            editorOptions={passwordEditorOptions}
          >
            <RequiredRule message="Password is required" />
            {/* <CustomRule
              message="Password must be 8-20 characters, include at least 1 uppercase letter, 1 lowercase letter, 1 digit, and 1 special character."
              validationCallback={passwordValidation}
            /> */}
          </Item>
          {/* <GroupItem
            colCountByScreen={{
              xs: 2, // 2 columns on extra small screens (mobile)
              sm: 2,
              md: 2,
              lg: 2,
            }}
            colSpan={12}
            // cssClass=""
          > */}
            {/* <Item
              dataField="rememberMe"
              editorType="dxCheckBox"
              label={{ visible: false }}
              editorOptions={{
                text: "Remember Me",
                elementAttr: { class: "form-text" },
              }}
            /> */}
            <Item>
              <div className="link">
                <Link to="/reset-password">Forgot Password?</Link>
              </div>
            </Item>
          {/* </GroupItem> */}
          <ButtonItem>
            <ButtonOptions
              width="100%"
              height="40px"
              type="default"
              useSubmitBehavior
            >
              <span className="dx-button-text">
                {loading ? (
                  <Loader />
                ) : (
                  "Sign in"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
      <div className="flex items-center justify-between mt-[70px]">
        <p className="m-0 text-xs">
          B’Logic<sup className="ms-[0.5px]">®</sup> 𝑖QMS
        </p>
        <p className="m-0 text-xs">All rights reserved - 2025</p>
      </div>
    </>
  );
}

const emailEditorOptions = {
  stylingMode: "outlined",
  placeholder: "Enter your email or username",
  mode: "email",
  buttons: [
    {
      name: "emailIcon",
      location: "before",
      options: { icon: "email", stylingMode: "text" },
    },
  ],
};

const rememberMeEditorOptions = {
  text: "Remember Me",
  elementAttr: { class: "form-text" },
};
